var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEquipmentFinancing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4395 34.14L21.7595 36.02L28.4695 20.63C28.9395 19.55 28.4495 18.3 27.3695 17.83L26.9495 17.65C25.8695 17.18 24.6195 17.67 24.1495 18.75L17.4395 34.14Z",
    fill: "#FFCF00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4395 34.14L21.7595 36.02L28.4695 20.63C28.9395 19.55 28.4495 18.3 27.3695 17.83L26.9495 17.65C25.8695 17.18 24.6195 17.67 24.1495 18.75L17.4395 34.14Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.129 12.69C32.739 12.76 31.669 13.95 31.669 15.35V16.52C31.669 19.78 28.929 22.39 25.619 22.18C22.749 22 20.449 19.64 20.329 16.77C20.209 14 22.079 11.66 24.619 11.02H24.629C24.639 11.02 24.659 11.01 24.679 11.01C25.959 10.71 28.499 10.1 28.499 6.1V1.92C28.499 1.41 28.089 1 27.579 1H24.419C23.909 1 23.499 1.41 23.499 1.92V4.49C23.499 5.32 22.979 6.07 22.199 6.36C17.959 7.95 14.969 12.11 15.159 16.95C15.379 22.54 19.899 27.09 25.479 27.35C31.699 27.64 36.839 22.68 36.839 16.52V15.28C36.839 13.8 35.619 12.62 34.129 12.69Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.129 12.69C32.739 12.76 31.669 13.95 31.669 15.35V16.52C31.669 19.78 28.929 22.39 25.619 22.18C22.749 22 20.449 19.64 20.329 16.77C20.209 14 22.079 11.66 24.619 11.02H24.629C24.639 11.02 24.659 11.01 24.679 11.01C25.959 10.71 28.499 10.1 28.499 6.1V1.92C28.499 1.41 28.089 1 27.579 1H24.419C23.909 1 23.499 1.41 23.499 1.92V4.49C23.499 5.32 22.979 6.07 22.199 6.36C17.959 7.95 14.969 12.11 15.159 16.95C15.379 22.54 19.899 27.09 25.479 27.35C31.699 27.64 36.839 22.68 36.839 16.52V15.28C36.839 13.8 35.619 12.62 34.129 12.69Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.019 34.14L30.699 36.02L23.989 20.63C23.519 19.55 24.009 18.3 25.089 17.83L25.509 17.65C26.589 17.18 27.839 17.67 28.309 18.75L35.019 34.14Z",
    fill: "#FFCF00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.019 34.14L30.699 36.02L23.989 20.63C23.519 19.55 24.009 18.3 25.089 17.83L25.509 17.65C26.589 17.18 27.839 17.67 28.309 18.75L35.019 34.14Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8299 34.1H8.16992V51H43.8299V34.1Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8299 34.1H8.16992V51H43.8299V34.1Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4199 40.05H36.8399",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4199 45.05H36.8399",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquipmentFinancing);
export default __webpack_public_path__ + "static/media/EquipmentFinancing.ba58425111c3a36285ee4bdfe0bac5d9.svg";
export { ForwardRef as ReactComponent };